export default {
  finalPrice: (price, msrp) => {
    price = price === null ? 0 : price
    msrp = msrp === null ? 0 : msrp
    var x = price > 0 ? price : msrp
    if (!Number.isInteger(x)) return x
    if (x === 0) return 'Call For Price'

    x = x.toString()

    var pattern = /(-?\d+)(\d{3})/
    while (pattern.test(x)) { x = x.replace(pattern, '$1,$2') }
    return '$' + x
  }
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/price.helper.js